export class RoutesMap {
  static CREDITO = 'credito';
  static REQUERIMIENTOS = 'requerimientos';
  static TRAMITES = 'tramites';  //ADD INE(JJGJ) 20221018 - REQ22978
  static SEGUROS = 'seguros';  //ADD INE(JJGJ) 20221018 - REQ22978
  static CONFIGURACIONES = 'configuraciones';  //ADD INE(JJGJ) 20221018 - REQ22978
  static COMPROBANTES = 'comprobantes';  //ADD INE(JJGJ) 20221018 - REQ22978
  // static TEMPLATE = 'template';

  // static AUTH = `${RoutesMap.HOME}auth`;
  // static AUTH_LOGIN = 'login';
  // static AUTH_LOGOUT = 'logout';

  static LISTA_CREDITO = `${RoutesMap.CREDITO}/lista`;
  static DETALLE_CREDITO = `${RoutesMap.CREDITO}/detalle`;
  static CRONOGRAMA = `${RoutesMap.CREDITO}/cronograma`;
  static IMPUESTO_VEHICULAR = `${RoutesMap.CREDITO}/impuestoVehicular`;
  static ESTADO_CUENTA = `${RoutesMap.CREDITO}/estadoCuenta`;
  static PAGO_CUOTA = `${RoutesMap.CREDITO}/pagoCuota`;
  static ACTUALIZAR_DATOS = `${RoutesMap.CREDITO}/actualizar`; //ADD INE(EGB) 20220709 - REQ22111
  static PREGUNTAS_FRECUENTES = `preguntasfrecuentes`;/***MOD - CSTI(EACN) 20231017 - REQ25710 ***/

  static RECLAMOS = `reclamos`;
  static CONCESIONARIO = 'concesionario';
  static ADMINISTRACION = 'administracion';
  static PREPAGO = 'prepago';
  static PREPAGOLISTA = 'listaprepago';
  static PREPAGOresgitro = `${RoutesMap.PREPAGO}/prepagoregistro`;

  //INI INE(JJGJ) 20221018 - REQ22978
  static CONFIG_PRUEBA_SERVICIOS = `${RoutesMap.CONFIGURACIONES}/servicios`;
  static CONFIG_PARAMETROS = `${RoutesMap.CONFIGURACIONES}/parametros`;
  static DETALLE_TRAMITES =  `${RoutesMap.TRAMITES}/detalle`;
  static DETALLE_SEGUROS =  `${RoutesMap.SEGUROS}/detalle`;
  static DESBLOQUEO_USUARIO = `${RoutesMap.CONFIGURACIONES}/desbloqueousuario`;
  //FIN INE(JJGJ) 20221018 - REQ22978
  static CREDITO_HEVICULAR = `${RoutesMap.CREDITO}/creditovehicular`; // ADD INE(JJGJ) 20231010 REQ25710
  static COMPROBANTES_PAGO = `${RoutesMap.COMPROBANTES}/miscomprobantes`; // ADD INE(JJGJ) 20231010 REQ25710
  //static PRESTAMO_PERSONAL = `${RoutesMap.CREDITO}/prestamopersonal`;/***MOD - CSTI(EACN) 20231017 - REQ25710 ***/ /* COMMENT EXP(CMOGOLLON) 20250220 REQ40119 */
}
